/**
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2022
 *
 *==================================================
 */

//Get current country list
export const COUNTRY_STATE_LIST_GET_REQUESTED = "COUNTRY_STATE_LIST_GET_REQUESTED";
export const COUNTRY_STATE_LIST_GET_SUCCESS = "COUNTRY_STATE_LIST_GET_SUCCESS";
export const COUNTRY_STATE_LIST_GET_ERROR = "COUNTRY_STATE_LIST_GET_ERROR";
